module.exports = __webpack_public_path__ + "img/img_half_wide_belt.0919a96e.png";